// uiGenerator.js
var UiGenerator = pc.createScript('uiGenerator');

UiGenerator.attributes.add('selector', {type:'entity'});
UiGenerator.attributes.add('collectorData', {type:'asset', assetType:'json'});
UiGenerator.attributes.add('planetInfo', {type:'entity'});


// initialize code called once per entity
UiGenerator.prototype.initialize = function() {
    this.app.on('hoverClick:clicked', this.clickedUI, this);
    this.app.on('solarGen:ActualSystem', this.setSystem, this);
    this.app.on('systemGenerator:reset', this.hideEnts, this);
    this.app.on('userInput:startOrbit',this.reset, this);
    //this.app.on('userInput:test', this.reset, this);
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    
    this.cd = this.collectorData.resource;
    this.camScript = this.app.root.findByName('Camera').script.cameraController;

    this.uiEnts = this.entity.children;
    this.thePlanet = null;
    this.thePlanetBak = null;
    this.entName = null;
    this.selector.enabled = false;
    this.cs = false;
    this.system = null;
    this.offPlanet = null;
    this.crossSection = this.crossSection = this.app.root.findByName('crossSection');
    this.lastButton = null;
    this.oneTime = false;
    this.bn = null;
    this.bsc = new pc.Vec3(0,0,0);
    this.collectorWasOn = -1;
   // console.info(this.entity)
    this.bn = this.entity.children[1].children[0].model.model.graph.findByName('Bone001');
    this.bsc = this.bn.getLocalScale();
    this.bakTxt = null;
    
    this.scaleAR = [new pc.Vec3(32,32,32),new pc.Vec3(55,55,55),new pc.Vec3(1,1,1),new pc.Vec3(32,32,32),new pc.Vec3(128,128,128)];
    
};

UiGenerator.prototype.setSystem = function(sys) {
    //console.log(sys.children[sys.children.length-1].name);
    this.system = sys;
};


UiGenerator.prototype.clickedUI = function(ent) {

    if(this.thePlanet.children[1] === undefined){
        this.hideEnts();
        return;
    }
    
    if(this.thePlanet == this.thePlanetBak){
        if(this.collectorWasOn > 0){
            this.planetInfo.element.text = this.bakTxt;
            this.collectorWasOn *= -1;
            } else {
                this.bakTxt = this.planetInfo.element.text;                       
        }
    } else {
        this.bakTxt = this.planetInfo.element.text;
    }



    // if(ent.name !== 'buttonAdUI9' && this.collectorWasOn > 0){
    //     this.bakTxt = this.planetInfo.element.text;
    // }

    this.lastButton = ent;
    var uniqueness = null;
    if(this.thePlanet.name !== 'system'){
        uniqueness = this.thePlanet.children[1].children[1].model.model.meshInstances[0].material.name;
    }
    
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.seedScript.getUniqueRandom()+uniqueness);

    if(this.entName !== null){
        if(this.entName.name == ent.name){
            if(this.entName.name == 'buttonAdUI8'){
                this.app.fire('uiGenerator:stopPlanetSound');
            }
            this.hideEnts();
            this.entName = null;
            return;
        }
    }
    
    if(!this.thePlanet){
        return;
    }

    this.hideEnts();
    this.selector.enabled = true;
    var pr = this.selector.parent;
    pr.removeChild(this.selector);
    ent.addChild(this.selector);
    
    if(ent.name === 'buttonUI0'){
        return;
    }
    
    var rnd = 0;
    if(ent.name == 'buttonAdUI1'){
        rnd = 0;
    } else if(ent.name == 'buttonAdUI2'){
        rnd = 1;
    } else if(ent.name == 'buttonAdUI3'){
        rnd = 2;
    } else if(ent.name == 'buttonAdUI4'){
        rnd = 3;
    } else if(ent.name == 'buttonAdUI5'){
        rnd = 4;
    } else if(ent.name == 'buttonAdUI6'){
        rnd = 5;
    } else if(ent.name == 'buttonAdUI7'){
        rnd = 6;
    } else if(ent.name == 'buttonAdUI8'){
        rnd = 7;
    } else if(ent.name == 'buttonAdUI9'){
        rnd = 8;
    }

    if(rnd < 5){
        this.uiEnts[rnd].enabled = true;
        this.uiEnts[rnd].setPosition(this.thePlanet.getPosition());
        this.uiEnts[rnd].lookAt(0,0,0);

        if(this.thePlanet.children[1].script.planetGenerator){
            this.uiEnts[rnd].setLocalScale(75,75,75);
        } else if(this.thePlanet.children[1].script.gasGiantGenerator){
            this.uiEnts[rnd].setLocalScale(200,200,200);
        }

        this.setUI(this.uiEnts[rnd]);
        
    } else if(rnd == 5){

        this.cs = true;
        this.crossSection.enabled = true;
        if(this.thePlanet.name == 'system'){
            var sn1 = this.system.findByName('sun_1');
            this.offPlanet = sn1;
            this.app.fire('uiGenerator:crossSectionOn', sn1);
        } else {
            this.app.fire('uiGenerator:crossSectionOn', this.thePlanet);
        }

    } else if(rnd == 6){

        this.cs = true;
        this.crossSection.enabled = true;
        if(this.thePlanet.name == 'system'){
            var sn2 = this.system.findByName('sun_2');
            this.offPlanet = sn2;
            this.app.fire('uiGenerator:crossSectionOn', sn2);
        } else {
            this.app.fire('uiGenerator:crossSectionOn', this.thePlanet);
        }
        
    }  else if(rnd == 7){

        
        this.app.fire('uiGenerator:stopMusic');
        this.app.fire('uiGenerator:playPlanetSound', this.thePlanet);

    } else if(rnd == 8){

        this.collectorWasOn *= -1;
        var sysNum = 0;
        var hit = false;

        for(var lst = 0; lst < this.cd.systems.length; lst++){
           
            var sd = parseFloat(this.cd.systems[lst].seed);
            if(sd == this.theSeed){
                sysNum = lst;
                hit = true;
            }
        }
                   
        if(hit){
            for(var pln = 0; pln < this.cd.systems[sysNum].planets.length; pln++){
                if(pln == this.camScript.planetCounter-1){
                    
                    if(this.collectorWasOn > 0){
                        //this.bakTxt = this.planetInfo.element.text;
                        this.app.fire('uiGenerator:CollectorGenerator:triggerCollectorText', this.cd.systems[sysNum].planets[pln].buyer, this.camScript.planetCounter, this.thePlanet, this.cd.systems[sysNum].multiEdition);
                        pln = this.cd.systems[sysNum].planets.length;
                    } else {
                        this.planetInfo.element.text = this.bakTxt;
                    }
                    //console.info(this.cd.systems[sysNum].planets[pln].buyer);
                   // console.log('this.thePlanet:' + this.thePlanet.name);
                } else {
                    if(this.cd.systems[sysNum].planets.length){
                        if(this.collectorWasOn > 0){
                            this.planetInfo.element.text = 'HAS NOT BEEN COLLECTED, YET!';
                        } else {
                            this.planetInfo.element.text = this.bakTxt;
                        }
                        
                    }
                }
            }
        } else {
            //console.log('backTxt: ' + this.bakTxt);
            //this.bakTxt = this.planetInfo.element.text;
            if(this.collectorWasOn > 0){
                this.planetInfo.element.text = 'HAS NOT BEEN COLLECTED, YET!';
            } else {
                console.log('backTxt: ' + this.bakTxt);
                this.planetInfo.element.text = this.bakTxt;
            }
            
        }
       

    }

   
    this.thePlanetBak = this.thePlanet;
    this.entName = ent;
};

UiGenerator.prototype.reset = function(){
    var ent = this.lastButton;
    if(this.entName !== null){
        if(this.entName.name == ent.name){
            this.hideEnts();
            this.entName = null;
           
        } else {
            this.hideEnts();
            this.entName = null;
        }
    }
};

UiGenerator.prototype.setUI = function(ent) {

    var sFactor = 0;
    if(this.thePlanet.name == 'gasGiant'){
        sFactor = 0.4;
    } else if(this.thePlanet.name == 'rockPlanet'){
        sFactor = 0.4;
    } else if(this.thePlanet.name == 'habitable'){
        sFactor = 0.4;
    }
    
    if(ent.name == 'orbit'){
        
    } else if(ent.name == 'gravity'){
        var tx = 0.9 + this.randomize()*sFactor;
        this.bn.setLocalScale(tx,  this.bsc.y, this.bsc.z);
        
    } else if(ent.name == 'magneticField'){
        var mScale = ent.getLocalScale();
        var rs = new pc.Vec3();
        rs.x = rs.z = (0.75 + this.randomize() * 0.75) * mScale.x;
        rs.y = (0.5 + this.randomize()*0.75) * mScale.y;
        ent.setLocalScale(rs.x, rs.y, rs.z);
    } else if(ent.name == 'metrics'){
        ent.rotate(0,this.randomize()*350, 0);
    } else if(ent.name == 'coordinates'){
        ent.rotate(0,this.randomize()*350, 0);
    }
    
    
};

UiGenerator.prototype.hideEnts = function(src){
  //  console.log('UIG:HIDENTS');
  
    //this.app.fire('uiGenerator:hideEnts');
    this.app.fire('uiGenerator:stopPlanetSound');
    this.bn.setLocalScale(1,1,1);
    for(var count = 0; count < this.uiEnts.length; count++){
        this.uiEnts[count].enabled = false;
        this.uiEnts[count].setLocalScale(this.scaleAR[count]);
    }
        
    if(this.cs){
        if(this.thePlanet.name == 'system'){
            this.app.fire('uiGenerator:crossSectionOff', this.offPlanet);
        } else {
            this.app.fire('uiGenerator:crossSectionOff', this.thePlanet);
        }
        this.cs = false;
    }

    //this.app.fire('uiGenerator:collectorGenerator:turnOff');
    this.selector.enabled = false;
};

// update code called every frame
UiGenerator.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// UiGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

